import VueService from "../service/VueService";

import HomeSlider from "./blocks/slider/home-slider.vue";
import TemplateConstructor from "./components/constructor/template-constructor.vue";

VueService.render(HomeSlider, '.vue-slider');
VueService.render(TemplateConstructor, '.vue-template-constructor');
